import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icon-36x36.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header-brand" }, "電カル", -1)
const _hoisted_4 = { class: "header-clinic" }
const _hoisted_5 = {
  key: 0,
  class: "header-nav-menu-icon-frame"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("施設を変更する")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ログアウト")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("ログアウトしますか？ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cloud_icon = _resolveComponent("cloud-icon")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_drop_down_item = _resolveComponent("drop-down-item")
  const _component_drop_down_frame = _resolveComponent("drop-down-frame")
  const _component_confirm = _resolveComponent("confirm")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.clinicName), 1),
    (_ctx.authenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_cloud_icon, { syncStatus: _ctx.syncStatus }, null, 8, ["syncStatus"]),
          _createVNode(_component_fa_icon, {
            class: "header-nav-menu-icon",
            icon: "home",
            onClick: _ctx.dashboard
          }, null, 8, ["onClick"]),
          _createVNode(_component_fa_icon, {
            class: "header-nav-menu-icon",
            icon: "user",
            onClick: _ctx.openAccountMenu
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_drop_down_frame, { ref: "accountMenuRef" }, {
      default: _withCtx(() => [
        (_ctx.clinicId !== '')
          ? (_openBlock(), _createBlock(_component_drop_down_item, {
              key: 0,
              onClick: _ctx.onExitClinic
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_drop_down_item, { onClick: _ctx.onLogout }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_confirm, {
      ref: "confirmRef",
      onYes: _ctx.yes
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["onYes"])
  ]))
}